<template>
  <b-container fluid class="dispatch-container">
    <b-row>
      <b-col>
        <b-form inline class="mb-2" @submit.prevent="applyFilters(false)">
          <h1 class="mr-2 mb-2">Dispatch</h1>
          <b-form-input
            v-model="queryFilters.number"
            placeholder="Search by order id"
            class="mr-2 mb-2 single-input"
          />
          <b-form-input
            v-model="queryFilters.delivery"
            placeholder="Search by delivery id"
            class="mr-2 mb-2 single-input"
          />
          <b-form-group class="custom-search-input mb-2 mr-2">
            <multiselect
              v-model="queryFilters.status"
              select-label=""
              open-direction="bottom"
              :options="statusOptions"
              track-by="value"
              deselect-label="remove"
              :searchable="false"
              :close-on-select="true"
              :show-no-results="false"
              :hide-selected="false"
              label="name"
              class="single-input"
              placeholder="Filter by status"
            />
          </b-form-group>
          <custom-search-field
            v-model="queryFilters.hub"
            class="mr-2 mb-2 single-input"
            :placeholder="'Filter by hub'"
            :path-to-search="'facilities'"
          />
          <custom-search-field
            v-model="queryFilters.network"
            class="mr-2 mb-2 single-input"
            :placeholder="'Filter by network'"
            :path-to-search="'networks'"
          />
          <b-button type="submit" variant="primary" class="mb-2 mr-2"
            >Filter</b-button
          >
          <b-button variant="primary" class="mb-2 mr-2" @click="resetFilters"
            >Clear</b-button
          >
          <img
            :src="asset('imgs/icons/refresh.png')"
            style="cursor: pointer"
            alt="refresh"
            width="20"
            height="20"
            @click="refreshRecord"
          />
        </b-form>
      </b-col>
    </b-row>
    <div class="dispatch-content-row">
      <b-col class="full-col">
        <order-items-table
          ref="dispatchOrderItems"
          @filterDelivery="filterDelivery"
        />
      </b-col>
      <b-col class="full-col">
        <orders-table ref="dispatchOrders" @filterDelivery="filterDelivery" />
      </b-col>
      <b-col class="half-col">
        <deliveries-table
          ref="pendingDeliveries"
          :statuses="'pending,preparing,ready'"
          :title="'Deliveries - Awaiting Pickup'"
          :collapsed="readyCollapsed"
          :expanded="enrouteCollapsed"
          class="mb-4"
          @filterDelivery="filterDelivery"
          @collapseToggled="onCollapseToggle('readyCollapsed')"
        />
        <deliveries-table
          ref="enrouteDeliveries"
          :statuses="'enroute'"
          :title="'Deliveries - En Route'"
          :collapsed="enrouteCollapsed"
          :expanded="readyCollapsed"
          @filterDelivery="filterDelivery"
          @collapseToggled="onCollapseToggle('enrouteCollapsed')"
        />
      </b-col>
    </div>
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex';
import DeliveriesTable from './DeliveriesTable.vue';
import OrderItemsTable from './OrderItemsTable.vue';
import OrdersTable from './OrdersTable.vue';

export default {
  name: 'Dispatch',
  components: { DeliveriesTable, OrderItemsTable, OrdersTable },
  data() {
    return {
      refreshTimer: null,
      queryFilters: {},
      rows: 0,
      readyCollapsed: false,
      enrouteCollapsed: false,
      statusOptions: [
        {
          value: 0,
          name: 'Late',
        },
        {
          value: 1,
          name: 'At Risk',
        },
        {
          value: 2,
          name: 'On Time',
        },
      ],
    };
  },
  computed: {
    ...mapGetters('session', ['filters']),
  },
  created() {
    this.setStoreFilters();

    this.$store.dispatch('session/hideSidebar');
  },
  mounted() {
    // Auto refresh interval
    this.refreshTimer = setInterval(() => {
      this.refreshRecord(true);
    }, 15000);
  },
  beforeDestroy() {
    clearInterval(this.refreshTimer);
  },
  methods: {
    setStoreFilters() {
      this.queryFilters = {
        network: this.filters.network ? this.filters.network : null,
        kitchen: this.filters.kitchen ? this.filters.kitchen : null,
        hub: this.filters.hub ? this.filters.hub : null,
        status: this.filters.status ? this.filters.status : null,
        number: this.filters.number ? this.filters.number : null,
        delivery: this.filters.delivery ? this.filters.delivery : null,
        limit: this.filters.limit ? this.filters.limit : 25,
        sort: this.filters.sort ? this.filters.sort : '',
        dir: this.filters.dir ? this.filters.dir : '',
      };
    },
    applyFilters(auto) {
      // Update applied filter state if not an auto refresh
      if (!auto) {
        this.$store.commit('session/updateFilters', {
          ...this.queryFilters,
          range: this.range,
        });
      }

      // Launch loadresults inside components via ref
      this.$refs.dispatchOrderItems.loadResults();
      this.$refs.dispatchOrders.loadResults();
      this.$refs.pendingDeliveries.loadResults();
      this.$refs.enrouteDeliveries.loadResults();
    },
    refreshRecord(auto) {
      this.applyFilters(auto);
    },
    resetFilters() {
      this.$store.dispatch('session/resetFilters');
      this.setStoreFilters();
      this.applyFilters(false);
    },
    filterOrder(number) {
      this.$store.dispatch('session/resetFilters');
      this.setStoreFilters();
      this.queryFilters.number = number;
      this.applyFilters(false);
    },
    filterDelivery(id) {
      this.$store.dispatch('session/resetFilters');
      this.setStoreFilters();
      this.queryFilters.delivery = id;
      this.applyFilters(false);
    },
    onCollapseToggle(field) {
      this[field] = !this[field];
    },
  },
};
</script>
